import { format } from 'date-fns';

export default function getTodayDate() {
  return format(new Date(), 'yyyy-MM-dd');
}
